import { memo, useState, useRef, useEffect } from 'react';
import type { NodeProps } from '@xyflow/react';
import { useStore, type AnnotationNode as TAnnotationNode } from '../store';

function AnnotationNodeImpl({ id, data, selected }: NodeProps<TAnnotationNode>) {
  const setAnnotationText = useStore((s) => s.setAnnotationText);
  const [editing, setEditing] = useState(false);
  const ref = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (editing) {
      ref.current?.focus();
      ref.current?.select();
    }
  }, [editing]);

  const bg = data.color ?? '#fef3c7';

  return (
    <div
      onDoubleClick={(e) => {
        e.stopPropagation();
        setEditing(true);
      }}
      style={{
        minWidth: 140,
        maxWidth: 420,
        padding: '10px 14px',
        background: bg,
        border: selected ? '2px solid #2f81f7' : '1px solid rgba(15, 23, 42, 0.14)',
        borderRadius: 'var(--radius)',
        fontSize: 13,
        color: '#1f2937',
        lineHeight: 1.45,
        boxShadow: selected
          ? '0 0 0 3px rgba(47, 129, 247, 0.22), 0 4px 10px rgba(15, 23, 42, 0.08)'
          : '0 1px 3px rgba(15, 23, 42, 0.08)',
        cursor: editing ? 'text' : 'move',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        fontWeight: 500,
      }}
    >
      {editing ? (
        <textarea
          ref={ref}
          defaultValue={data.text}
          onBlur={(e) => {
            setAnnotationText(id, e.target.value);
            setEditing(false);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Escape') {
              (e.target as HTMLTextAreaElement).blur();
            }
          }}
          className="nodrag"
          style={{
            width: '100%',
            minWidth: 160,
            minHeight: 60,
            border: 'none',
            background: 'transparent',
            color: 'inherit',
            font: 'inherit',
            fontWeight: 'inherit',
            lineHeight: 'inherit',
            resize: 'both',
            outline: 'none',
            padding: 0,
          }}
        />
      ) : data.text ? (
        data.text
      ) : (
        <span style={{ color: '#92400e', fontStyle: 'italic' }}>
          Double-click to edit
        </span>
      )}
    </div>
  );
}

export const AnnotationNode = memo(AnnotationNodeImpl);
